import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getHardwareCategories } from '@/lib/api';
import { motion } from 'framer-motion';
import { fadeUp, stagger } from '@/lib/motion';
import { PageHero, Section, SectionTitle } from '@/components/shared/Section';
import { ShieldCheck, ArrowRight, MessageCircle, Monitor, CreditCard, Search, Scale, Tag, Tv, Plane, BatteryCharging, Printer, Scan, Cpu, RefreshCw, Server } from 'lucide-react';

const iconMap = { 'kioscos-autoservicio': Monitor, 'pos': CreditCard, 'price-checkers': Search, 'balanzas-comerciales': Scale, 'pesaje-industrial': Scale, 'esl': Tag, 'carteleria-digital': Tv, 'aeropuertos': Plane, 'airport-charging': BatteryCharging, 'impresion': Printer, 'scanners': Scan, 'perifericos': Cpu, 'refurb': RefreshCw, 'servidores-lenovo': Server };

export default function HardwareHub() {
  const [categories, setCategories] = useState([]);
  useEffect(() => { getHardwareCategories().then(r => setCategories(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <PageHero badge="CATÁLOGO HARDWARE" badgeIcon={ShieldCheck} h1="Hardware premium para tu operación" subtitle="Kioscos, POS, balanzas, ESL, cartelería, aeropuertos, servidores y más. Todo disponible en compra o arriendo."
        primaryCTA={<Link to="/contacto" className="inline-flex items-center justify-center gap-2 px-6 py-3.5 text-sm font-semibold text-white bg-[#0EA5E9] rounded-xl hover:bg-sky-600 shadow-lg">Cotizar hardware <ArrowRight className="w-4 h-4" /></Link>}
        secondaryCTA={<a href="https://wa.me/56975294340?text=Hola,%20quiero%20cotizar%20hardware" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-6 py-3.5 text-sm font-semibold text-emerald-400 border border-emerald-400/30 rounded-xl hover:bg-emerald-400/10"><MessageCircle className="w-4 h-4" /> WhatsApp</a>}
      />
      <Section>
        <SectionTitle badge="CATEGORÍAS" title="Explora nuestro catálogo" subtitle="14 categorías de hardware con las mejores marcas del mercado." center />
        <motion.div variants={stagger} className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {categories.map((cat) => {
            const Icon = iconMap[cat.slug] || Monitor;
            return (
              <motion.div key={cat.slug} variants={fadeUp}>
                <Link to={`/hardware/${cat.slug}`} className="group block p-5 rounded-2xl bg-white border border-slate-200 shadow-sm card-hover h-full">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 rounded-lg bg-sky-50 flex items-center justify-center group-hover:bg-[#0EA5E9] transition-colors">
                      <Icon className="w-5 h-5 text-[#0EA5E9] group-hover:text-white transition-colors" />
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold group-hover:text-[#0EA5E9] transition-colors">{cat.name}</h3>
                      <span className="text-xs text-[#64748B]">{cat.product_count} productos</span>
                    </div>
                  </div>
                  <p className="text-xs text-[#64748B] leading-relaxed">{cat.description}</p>
                </Link>
              </motion.div>
            );
          })}
        </motion.div>
      </Section>
    </div>
  );
}
